import { api } from '../lib/api'

export type PaymentRow = {
  readonly id: number
  readonly order_id: string
  readonly state: string
  readonly paid_at: string
  readonly amount: number
  readonly begin_date: string
  readonly end_date: string
  readonly path: string
}

export type PaymentsIndex = {
  readonly payments: readonly PaymentRow[]
  readonly profile_path: string
}

export type PaymentDetail = {
  readonly payment: {
    readonly order_id: string
    readonly amount: number
    readonly description: string | null
    readonly paid_at: string
    readonly state: string
    readonly begin_date: string
    readonly end_date: string
  }
  readonly first_payment: boolean
  readonly payments_path: string
  readonly profile_path: string
}

export type PlanRef = { readonly code: string; readonly name: string; readonly price: number }

type PaymentPaths = {
  readonly webpay_path: string
  readonly electronic_transfer_path: string
  readonly check_pending_payment_path: string
  readonly profile_path: string
}

export type NewPaymentScreen = PaymentPaths & {
  readonly screen: 'new'
  readonly plans: readonly PlanRef[]
  readonly plans_by_code: Readonly<Record<string, { readonly price: number; readonly name: string }>>
  readonly monthly_price: number
  readonly freemium: boolean
}

export type UpgradePaymentScreen = PaymentPaths & {
  readonly screen: 'upgrade'
  readonly plans: readonly PlanRef[]
  readonly plans_by_code: Readonly<Record<string, { readonly price: number; readonly name: string }>>
  readonly current_paid_payment: {
    readonly amount: number
    readonly begin_date: string
    readonly end_date: string
    readonly remaining_periods: number
    readonly credit_amount_for_update_payment: number
  }
}

export type RedirectScreen = { readonly redirect: string; readonly notice?: string; readonly warning?: string }

export type PaymentScreen = NewPaymentScreen | UpgradePaymentScreen | RedirectScreen

export type PendingPayment = {
  readonly title: string | null
  readonly amount: number
  readonly description: string | null
  readonly flow_url: string | null
  readonly cancel_path: string
}

export function fetchPayments(healthCenterId: number): Promise<PaymentsIndex> {
  return api.get<PaymentsIndex>(`/health_centers/${healthCenterId}/payments.json`)
}

export function fetchPayment(healthCenterId: number, id: string, gwp: boolean): Promise<PaymentDetail> {
  return api.get<PaymentDetail>(`/health_centers/${healthCenterId}/payments/${id}.json${gwp ? '?gwp=true' : ''}`)
}

export function fetchPaymentScreen(healthCenterId: number): Promise<PaymentScreen> {
  return api.get<PaymentScreen>(`/health_centers/${healthCenterId}/payments/new.json`)
}

export function fetchPendingPayment(path: string): Promise<{ pending_payment: PendingPayment | null }> {
  return api.get<{ pending_payment: PendingPayment | null }>(`${path}.json`)
}

export function cancelPendingPayment(path: string): Promise<void> {
  return api.delete<void>(path)
}
